import PropTypes from "prop-types"
import React from "react"

import BaseAvatar from "src/components/BaseAvatar"
import Button from "src/components/Button"
import Heading from "src/components/Heading"

const GuestSignInNudge = ({
  authPhotoUrl,
  contact,
  onSignIn,
  onSkip,
  signInUrl,
}) => {
  const greetingName = contact.firstName || contact.email

  return (
    <div className="-mt-5 flex min-h-screen w-full flex-wrap items-stretch">
      <div className="flex w-full flex-col items-center justify-center px-4 py-16 md:w-3/5">
        <Heading.PageTitle>
          {greetingName ? `Welcome back ${greetingName}!` : "Welcome back!"}
        </Heading.PageTitle>

        <p className="mt-2 text-gray-700">
          Your email is already registered. Sign in to make signing your
          agreement even faster.
        </p>

        <div className="mx-auto w-full xl:w-3/4">
          <div className="my-6 flex items-center justify-between gap-4 rounded-lg border px-4 py-4 shadow-md">
            <div className="flex items-center gap-3">
              <BaseAvatar
                src={contact.thumbnailUrl}
                name={contact.name}
                backgroundColor={
                  contact.thumbnailUrl
                    ? undefined
                    : contact.avatarBackgroundColor
                }
              />
              <div className="flex flex-col">
                <span className="font-semibold text-gray-900">
                  {contact.name}
                </span>
                <span className="text-gray-700">{contact.email}</span>
              </div>
            </div>
            <span className="font-semibold text-teal-600">
              Existing account
            </span>
          </div>

          <a
            href={signInUrl}
            className="btn btn-primary w-full"
            onClick={onSignIn}
          >
            Sign In
          </a>

          <div className="mt-3">
            <Button variant="link" fullWidth onClick={onSkip}>
              Skip (Not Recommended)
            </Button>
          </div>
        </div>
      </div>

      <div
        data-testid="auth-photo-panel"
        className="hidden bg-gray-200 md:block md:w-2/5"
        style={
          authPhotoUrl
            ? {
                backgroundImage: `url(${authPhotoUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }
            : undefined
        }
      />
    </div>
  )
}

GuestSignInNudge.propTypes = {
  authPhotoUrl: PropTypes.string,
  contact: PropTypes.shape({
    firstName: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    avatarBackgroundColor: PropTypes.string,
  }).isRequired,
  onSignIn: PropTypes.func,
  onSkip: PropTypes.func.isRequired,
  signInUrl: PropTypes.string.isRequired,
}

export default GuestSignInNudge
